import router from '../router'
import store from '../store'
import bus from "../api/bus.js"
import { getTokenInfo, getUserInfo, getMenu, getExpire } from '../utils/auth'
// import enc from "@/utils/enc"
import { isLocal } from "@/settings.js"

//白名单
const whiteList = ['/login']
const noRedirectlist = ['/home', '/404', '/']

const getOtherQuery = (query) => {
  return Object.keys(query).reduce((acc, cur) => {
    if (cur !== "redirect") {
      acc[cur] = query[cur];
    }
    return acc;
  }, {});
}
const flrPath = () => {
  // 判断设置的几个目录是否存在
  const menuList = JSON.stringify(getMenu())
  if (menuList.indexOf('hospitallist') >= 0 && menuList.indexOf('医院列表') >= 0) {
    return '/hospital/list'
  } else {
    return '/'
  }
}
const expiresCalculation = () => {
  const expires = getExpire() || 0
  const nDate = new Date()
  const nTime = nDate.getTime()
  const nTimeSecond = Math.floor(nTime / 1000)
  const expTime = expires - nTimeSecond
  console.log(expTime)
  return expTime
}

router.beforeEach(async (to, from, next) => {
  // 判断用户是否登录
  const hasToken = getTokenInfo()
  if (isLocal) {
    next()
    return
  }
  // 扫码验证二维码打开的页面关掉停机更新提示
  if (to.path === '/ddverify') {
    window.g.SYSUPDATE = false
  }
  // 中台跳转
  if (to.path === '/consultationLogin') {
    // const _aestoken = to.query.token
    // if (_aestoken) {
    //   const _tokenObj = JSON.parse(enc.AESDecrypt(decodeURIComponent(_aestoken)))
    //   await store.dispatch('user/setNewTokenInfo', _tokenObj)
    // }
    next()
    return
  } else if (to.path === '/workorder') {
    next()
    return
  }

  const query = to.query;
  let redirect = ''
  let otherQuery = null;
  if (query) {
    redirect = to.path;
    otherQuery = getOtherQuery(query);
  }

  if (hasToken) {
    if (expiresCalculation() < 0) {
      // token 过期，退出登录
      await store.dispatch('user/logout')
      next({
        path: '/login',
        query: { ...otherQuery, 'redirect': to.path }
      })
    } else {
      if (!getUserInfo()) {
        // 获取用户信息
        await store.dispatch('user/getUserInfo')
        // 获取用户菜单
        // 本地
        await store.dispatch('user/getMenuLocal')
      }
      if (to.path == '/login') {
        next({ path: flrPath() })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      if (noRedirectlist.indexOf(to.path) !== -1) {
        if(getUserInfo()){
          bus.$message.warning('登录状态已失效，请重新登录！');
        }
        await store.dispatch('user/logout')
        next(`/login`)
      } else {
        if(getUserInfo()){
          bus.$message.warning('登录状态已失效，请重新登录！');
        }
        await store.dispatch('user/logout')
        next({
          path: '/login',
          query: { ...otherQuery, 'redirect': to.path }
        })
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/modules/web/router/permission.js